const ydRouter = [
  {
    path: '/ChinaASEANInfo',
    name: 'ChinaASEANInfo',
    //redirect: '/ChinaASEANInfo',
    component: () => import(/* webpackChunkName: "SilkRoadData" */ '@/views/cnfinance/ChinaASEANInfo'),
    meta: {
      tagV: "v4"
    },
    children: [
    ]
  },
  {
    path: '/ChinaASEANInfo/ChinaASEANInfoCountry',
    name: 'ChinaASEANInfoCountry',
    //redirect: '/ChinaASEANInfo',
    component: () => import(/* webpackChunkName: "SilkRoadData" */ '@/views/cnfinance/ChinaASEANInfoCountry'),
    meta: {
      tagV: "v4"
    },
    children: [
    ]
  },
  {
    name: 'ChinaFinance',
    path: '/ChinaInformationV2/:id',
    component: () => import('@/views/cnfinance/ChinaInformationV2'),
    children: [{
      name: 'ChinaFinanceArticle',
      path: 'article/:contentid',
      component: () => import('@/views/cnfinance/components/ArticleDetails/ChinaFinanceArticle'),
    }]
  }, //中国金融
  {
    path: '/Finance',
    name: 'Finance',
    // redirect:'/data/Finance/Industry',
    component: () => import('@/views/cnfinance/Finance'),
    meta: {
      tagV: "v4"
    },
    children: [
      {
        path: 'Xinhua500Index',
        name: 'Xinhua500Index',
        component: () => import(/* webpackChunkName: "SilkRoadData" */ '@/views/cnfinance/dashboard'),
        meta: {
          tagV: "v4"
        }
      },
      {
        path: 'IronOreIdxPrice',
        name: 'IronOreIdxPrice',
        component: () => import('@/views/cnfinance/components/ArticleDetails/IronOreIdxPrice'),
        meta: {
          tagV: "v4"
        }
      },
      {
        path: '/Bond',
        name: 'Bond',
        component: () => import('@/views/cnfinance/Bond'),
        redirect: '/bond/base_info',
        meta: {
          tagV: "v4"
        },
        children: [
          { path: 'base_info', name: 'base_info', nameCN: '基本条款', component: () => import('@/views/cnfinance/bond/base_info'), meta: { tagV: "v4" } },
          { path: 'issuance_status', name: 'issuance_status', nameCN: '发行情况', component: () => import('@/views/cnfinance/bond/issuance_status'), meta: { tagV: "v4" } },
          { path: 'cash_flow', name: 'cash_flow', nameCN: '现金流', component: () => import('@/views/cnfinance/bond/cash_flow'), meta: { tagV: "v4" } },
          { path: 'same_issuer', name: 'same_issuer', nameCN: '相同发行人债券', component: () => import('@/views/cnfinance/bond/same_issuer'), meta: { tagV: "v4" } },
          { path: 'sh_valuation', name: 'sh_valuation', nameCN: '上清所估值', component: () => import('@/views/cnfinance/bond/sh_valuation'), meta: { tagV: "v4" } },
        ]
      },
    ]
  },
]
export default ydRouter
